import { latlongRegExp } from './mapbox'

export const isValidLatlong = (latlong: string): boolean =>
  latlongRegExp.test(latlong)

export const isValidLatlongOrBlank = (latlong: string): boolean =>
  latlong.length === 0 || isValidLatlong(latlong)
